import React from 'react';
import './Bulbcovertabl.css';



const Bulbcovertabl = () => {
    return (
        <div className="mold-container">
            <h2 className="heading">LED Bulb Cover Injection Molding Production</h2>
            <p><strong>Case for reference:</strong></p>
            <div className="details-grid">
                <div className="left-column">
                    <p><strong>Machine Model</strong> </p>
                    <p><strong>Product</strong> </p>
                    <p><strong>Mold Cavity</strong> </p>
                    <p><strong>Weight</strong></p>
                    <p><strong>Cycle Time</strong></p>
                    <p><strong>Material</strong></p>

                </div>
                <div className="right-column">
                    <p>	IBM288R-S6</p>
                    <p>LED Cover A60</p>
                    <p>	16 Cavities</p>
                    <p>	6.5g</p>
                    <p>	19s</p>
                    <p>	PC</p>

                </div>
            </div>
        </div>
    );
};

export default Bulbcovertabl;
